<template>
	<div class="page-detail">	
		<div class="page-detail-inner">
			<FichaEstructura 
				:id="id" 
				:entidad="entidad"
				:asideDrawer="false"
				:asideStatic="true"
				:detailPage="true"
				@openWindow="nuevaVentana"/>
		</div>
	</div>
</template>

<script>
	import FichaEstructura from '@/components/FichaEstructura.vue'

	export default {
		metaInfo() {
			return {
				title: this.id ? `${this.entidad.toUpperCase()} ${this.id}` : this.entidad.toUpperCase()
			}
		},
		name: 'Detail',
		components: {
			FichaEstructura
		},
		props: {
			id: String,
			entidad: String
		},
		methods: {
			nuevaVentana(value) {

				let url = ''

				if(window.distributionapp.publicPath) {
					
					url = `${window.location.origin}/${window.distributionapp.publicPath}/${value.entidad}/${value.id}`
						
				} else {

					url = `${window.location.origin}/${value.entidad}/${value.id}`
				}

				this.openwindow(`${url}`, '_blank')
			}
		}
	}
</script>

<style lang="scss">
.page-detail {
    height: 100vh;
    background-color: white;

	.page-detail-inner {
		width: 100%;
		height: 100%;
		position: relative;
		overflow: auto;
	}
}
</style>
